import { apiEndPoint } from 'config';
import { apiConstants } from '../constants';
import { authHeader, handleResponse } from 'helpers';
import { queryFilters, queryWhere } from '../helpers/util';

export const configService = {
  getAll,
  update
};

function getAll(filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  var url = apiConstants.getAllConfigurations;
  if (filters) url = url.concat('', queryWhere(filters, true));
  return fetch(url, requestOptions)
    .then(handleResponse);

}

function update(updatedValues) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };
  var url = apiConstants.updateConfigurations;
  return fetch(url, requestOptions)
    .then(handleResponse);
}
